export default import.meta.ROLLDOWN_FILE_URL_2h$eqWdLjjj$zuUvyPi$HQ